import { GlButton, GlIcon, GlLink, GlPopover, GlSprintf } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'FreeVsPremiumComparisonTable',
    components: {
        GlButton,
        GlIcon,
        GlLink,
        GlPopover,
        GlSprintf
    },
    props: {
        // { id, title, freeIncluded, ...popover fields }; Premium is always included.
        rows: {
            type: Array,
            required: true
        },
        showFeaturePopovers: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'popover-shown',
        'popover-click'
    ],
    i18n: {
        free: __('Free'),
        premium: __('Premium'),
        included: __('Included'),
        notIncluded: __('Not included'),
        learnMore: __('Learn more')
    },
    methods: {
        rowElementId (id) {
            return `${id}FreeVsPremiumComparisonTable`;
        },
        isRowLinked (row) {
            return this.showFeaturePopovers && Boolean(row.docsLink);
        },
        rowHeightClass (index) {
            return index === 0 ? 'gl-h-12' : 'gl-h-11';
        },
        includedText (included) {
            return included ? this.$options.i18n.included : this.$options.i18n.notIncluded;
        }
    }
};
